// extracted by mini-css-extract-plugin
module.exports = {"shareCodeDialogWhole":"shareCodeDialogWhole","shareCodeContainer":"shareCodeContainer","shareCodeDialogButton":"shareCodeDialogButton","codeArea":"codeArea"};